import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const [siteConfig, setSiteConfig] = useState(null);

  useEffect(() => {
    const fetchSiteConfig = async () => {
      try {
        const response = await axios.get(`${API}/site-config`);
        setSiteConfig(response.data);
      } catch (error) {
        console.error('Error fetching site config:', error);
      }
    };
    fetchSiteConfig();
  }, []);

  const getLogoUrl = (url) => {
    if (!url) return null;
    return url.startsWith('/') ? `${BACKEND_URL}${url}` : url;
  };

  return (
    <footer 
      className="bg-[var(--surface)] border-t border-white/5"
      data-testid="main-footer"
    >
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-6">
              {siteConfig?.logo_url ? (
                <img 
                  src={getLogoUrl(siteConfig.logo_url)} 
                  alt={siteConfig?.site_name || 'Event Cinema'} 
                  className="h-10 object-contain"
                />
              ) : (
                <span className="font-['Playfair_Display'] text-2xl font-bold tracking-tight">
                  <span className="text-[var(--primary)]">Event</span>
                  <span className="text-white">Cinema</span>
                </span>
              )}
            </Link>
            <p className="text-white/50 text-sm leading-relaxed">
              Plataforma oficial de Versión Digital. Ópera, ballet, conciertos y teatro en tu cine.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[var(--primary)] mb-6">
              Navegación
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/catalogo" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-catalogo"
                >
                  Catálogo
                </Link>
              </li>
              <li>
                <Link 
                  to="/calendario" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-calendario"
                >
                  Calendario
                </Link>
              </li>
              <li>
                <Link 
                  to="/ciudades" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-ciudades"
                >
                  Ciudades
                </Link>
              </li>
            </ul>
          </div>

          {/* Genres */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[var(--primary)] mb-6">
              Géneros
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/catalogo?genre=opera" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                >
                  Ópera
                </Link>
              </li>
              <li>
                <Link 
                  to="/catalogo?genre=ballet" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                >
                  Ballet
                </Link>
              </li>
              <li>
                <Link 
                  to="/catalogo?genre=concierto" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                >
                  Conciertos
                </Link>
              </li>
              <li>
                <Link 
                  to="/catalogo?genre=teatro" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                >
                  Teatro
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[var(--primary)] mb-6">
              Información
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/sobre-nosotros" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                >
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link 
                  to="/condiciones" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                >
                  Condiciones de Compra
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:entradas@eventcinema.es" 
                  className="text-white/50 hover:text-white transition-colors text-sm"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5">
          {/* Footer Logo - Versión Digital */}
          {siteConfig?.footer_logo_url && (
            <div className="flex justify-center mb-8">
              <img 
                src={getLogoUrl(siteConfig.footer_logo_url)} 
                alt="Versión Digital" 
                className="h-16 object-contain"
              />
            </div>
          )}
          
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/30 text-sm">
              © {new Date().getFullYear()} {siteConfig?.site_name || 'Event Cinema'} - Versión Digital. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/aviso-legal" className="text-white/30 hover:text-white/50 text-sm transition-colors">
                Aviso Legal
              </Link>
              <Link to="/privacidad" className="text-white/30 hover:text-white/50 text-sm transition-colors">
                Privacidad
              </Link>
              <Link to="/politica-cookies" className="text-white/30 hover:text-white/50 text-sm transition-colors">
                Política de Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
